import { AnimationCanvas } from '@Components/animation/canvas/canvas'

import {
  AnimationAddOnPanel,
  AnimationAddOnPanelProps,
} from '@Components/animation/add-on-panel/animation-add-on-panel'

import './styles.scss'
import { useScreenWake } from '@Util/screen-wake.ts'
import {
  AwaitingNextDrawModal,
  AwaitingNextDrawModalProps,
} from '@Components/animation/awaiting-next-draw/awaiting-next-draw'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'

const CLASS_NAME = 'gby-k2g-watch-animation-screen'

export type WatchAnimationProps = {
  animationReady: boolean
  addOnPanelProps: AnimationAddOnPanelProps
  awaitingNextDrawProps: AwaitingNextDrawModalProps | null
  controls: JSX.Element
  adaDescription: string | null
  title: string
}

export const WatchAnimation = ({
  animationReady,
  adaDescription,
  addOnPanelProps,
  awaitingNextDrawProps,
  controls,
  title,
}: WatchAnimationProps) => {
  useScreenWake()

  return (
    <div className={CLASS_NAME}>
      <div className={`${CLASS_NAME}__title`} role={'heading'} aria-level={1}>
        {title}
      </div>
      {awaitingNextDrawProps ? null : <AnimationAddOnPanel {...addOnPanelProps} />}

      <VisuallyHidden>
        {adaDescription ? <p className={`${CLASS_NAME}__sr-desc`}>{adaDescription}</p> : ''}
      </VisuallyHidden>

      <AnimationCanvas
        isLoading={!animationReady && awaitingNextDrawProps === null}></AnimationCanvas>
      {awaitingNextDrawProps ? <AwaitingNextDrawModal {...awaitingNextDrawProps} /> : null}

      <div className={`${CLASS_NAME}__sticky-footer`}>{controls}</div>
    </div>
  )
}
